import React from 'react';
import { isClientMobie, useClientMobile } from '../../utils/device';

export const NearWallet = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1053 17.7695V31.4934L22.9474 26.25L23.6316 26.8654L17.894 35.1541C15.7622 37.16 12 35.8028 12 33.0278V16.0832C12 13.2131 15.9825 11.9058 18.0379 14.1012L33.8947 31.038V17.8772L27.7368 22.5575L27.0526 21.9421L31.9327 14.2049C33.9696 11.9688 38 13.2643 38 16.1551V32.7243C38 35.5944 34.0175 36.9017 31.9621 34.7063L16.1053 17.7695Z"
        fill="black"
      />
    </svg>
  );
};

export const NearWalletLarge = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(1.22,1.22)"
    >
      <circle cx="25" cy="25" r="25" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1053 17.7695V31.4934L22.9474 26.25L23.6316 26.8654L17.894 35.1541C15.7622 37.16 12 35.8028 12 33.0278V16.0832C12 13.2131 15.9825 11.9058 18.0379 14.1012L33.8947 31.038V17.8772L27.7368 22.5575L27.0526 21.9421L31.9327 14.2049C33.9696 11.9688 38 13.2643 38 16.1551V32.7243C38 35.5944 34.0175 36.9017 31.9621 34.7063L16.1053 17.7695Z"
        fill="black"
      />
    </svg>
  );
};

export const SenderWalletIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="50px"
      height="50px"
      viewBox="0 0 216 216"
      enableBackground="new 0 0 216 216"
      xmlSpace="preserve"
    >
      {' '}
      <image
        id="image0"
        width="216"
        height="216"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANgAAADYCAYAAACJIC3tAAABYmlDQ1BpY2MAACiRdZC9S8NQFMVP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"
      />
    </svg>
  );
};

export const SenderWallet = () => {
  return (
    <div
      className="relative"
      style={{
        width: '50px',
        height: '50px',
      }}
    >
      <SenderWalletIcon />
    </div>
  );
};

export const SenderWalletLarge = () => {
  return (
    <svg
      width="108px"
      height="108px"
      viewBox="0 0 108 108"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      transform="scale(0.55,0.55)"
      className="relative "
    >
      <title>symble-Round</title>
      <g
        id="ding_gao_large"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Sender-svg" transform="translate(-468.000000, -240.000000)">
          <g id="1" transform="translate(240.000000, 240.000000)">
            <g id="symble-Round" transform="translate(228.000000, 0.000000)">
              <rect
                fill="#2E79DF"
                x="0"
                y="0"
                width="108"
                height="108"
                rx="54"
              ></rect>
              <path
                d="M65.3535723,47.8259044 C66.423724,48.2167791 67.406505,48.7274833 68.2795269,49.3551942 C69.4412683,50.190381 70.408475,51.2336601 71.1254139,52.4802887 C71.4941051,53.1213769 71.7834404,53.7926612 71.9958132,54.4878511 C72.2105959,55.1881817 72.3480062,55.9126555 72.4108473,56.6547446 C72.8552218,61.8723729 69.6358409,67.9397998 63.9066211,72.4470451 L63.6479705,72.648171 C62.6515755,73.4136403 61.5813969,74.1325285 60.4436859,74.791951 L34.2050215,90 C33.4350533,84.8860992 34.8553819,79.6336869 38.1026016,75.5843891 C39.506399,73.8331495 41.2517969,72.3072225 43.3095947,71.1145135 L58.6371354,62.2306013 C60.726081,61.019839 62.0540083,58.9960482 62.4486265,56.794623 C62.7626841,55.0441289 62.486735,53.1817912 61.5343413,51.5257488 C60.7685257,50.1941321 59.6687489,49.1759357 58.4003207,48.5153576 C56.9586035,47.7634507 55.2985204,47.4737035 53.6638143,47.7107739 C53.7561593,47.6670566 53.8487994,47.6248027 53.9417345,47.5840122 C55.3327512,47.2386692 56.707016,47.019077 58.0407362,46.9237717 C60.7027283,46.7341397 63.2034763,47.0394796 65.3535723,47.8259044 Z M73.7949785,18 C74.5649467,23.1139008 73.1446181,28.3663131 69.8973984,32.4156109 C68.493601,34.1668505 66.7482031,35.6927775 64.6904053,36.8854865 L49.3628646,45.7693987 C47.273919,46.980161 45.9459917,49.0039518 45.5513735,51.205377 C45.2373159,52.9558711 45.513265,54.8182088 46.4656587,56.4742512 C47.2314743,57.8058679 48.3312511,58.8240643 49.5996793,59.4846424 C51.0413965,60.2365493 52.7014796,60.5262965 54.3361857,60.2892261 C54.2438407,60.3329434 54.1512006,60.3751973 54.0582655,60.4159878 C52.6672488,60.7613308 51.292984,60.980923 49.9592638,61.0762283 C47.2972717,61.2658603 44.7965237,60.9605204 42.6464277,60.1740956 C41.576276,59.7832209 40.593495,59.2725167 39.7204731,58.6448058 C38.5587317,57.809619 37.591525,56.7663399 36.8745861,55.5197113 C36.5058949,54.8786231 36.2165596,54.2073388 36.0041868,53.5121489 C35.7894041,52.8118183 35.6519938,52.0873445 35.5891527,51.3452554 C35.1447782,46.1276271 38.3641591,40.0602002 44.0933789,35.5529549 L44.3520295,35.351829 C45.3484245,34.5863597 46.4186031,33.8674715 47.5563141,33.208049 L73.7949785,18 Z"
                id="形状结合"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RefWalletLarge = () => {
  return (
    <svg
      width="62"
      height="63"
      viewBox="0 0 62 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31" cy="31.4118" r="30" fill="black" />
      <circle
        cx="31"
        cy="31.4118"
        r="30.5"
        stroke="#00C6A2"
        strokeOpacity="0.3"
      />
      <path
        d="M34.9268 45.8115H45.3995L34.9268 35.3387V45.8115Z"
        fill="white"
      />
      <path
        d="M45.3994 17.0117L39.2903 17.0117L45.3994 23.1208L45.3994 17.0117Z"
        fill="#00C6A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.362 35.339C35.2154 35.339 35.0696 35.3352 34.9248 35.3277V28.7744L42.0548 22.1537C43.0596 23.5254 43.6529 25.2174 43.6529 27.0481C43.6529 31.627 39.941 35.339 35.362 35.339ZM40.1932 20.3094L34.9248 25.2015V18.7685C35.0696 18.761 35.2154 18.7572 35.362 18.7572C37.1646 18.7572 38.8329 19.3325 40.1932 20.3094Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0557 18.7572H26.2012V26.506L29.7256 30.0304L34.0557 26.0096V18.7572ZM34.0557 29.5824L29.6583 33.6658L26.2012 30.2087V45.8117H34.0557V29.5824Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3259 18.7572H16.5986V29.998L23.1453 23.4514L25.3259 25.6319V18.7572ZM25.3259 29.3346L23.1453 27.154L16.5986 33.7007V45.8118H25.3259V29.3346Z"
        fill="white"
      />
    </svg>
  );
};

export const LedgerTransaction = () => {
  return (
    <svg
      width="64"
      height="57"
      viewBox="0 0 64 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6035 14.4H24.0035V31.8H34.8035V34.2H21.6035V14.4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8008 0L19.8008 2.4L2.40078 2.4L2.40078 13.2L0.000777919 13.2L0.000778496 -8.65486e-07L19.8008 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8008 48L19.8008 45.6L2.40078 45.6L2.40078 34.8L0.000777919 34.8L0.000778496 48L19.8008 48Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8008 48L34.8008 45.6L52.2008 45.6L52.2008 34.8L54.6008 34.8L54.6008 48L34.8008 48Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8008 0L34.8008 2.4L52.2008 2.4L52.2008 13.2L54.6008 13.2L54.6008 -8.65486e-07L34.8008 0Z"
        fill="white"
      />
      <path
        d="M63 40.5C63 49.0604 56.0604 56 47.5 56C38.9396 56 32 49.0604 32 40.5C32 31.9396 38.9396 25 47.5 25C56.0604 25 63 31.9396 63 40.5Z"
        fill="#1D2932"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.8833 24.0783C46.4155 24.0265 46.9548 24 47.5 24C48.0452 24 48.5845 24.0265 49.1167 24.0783C49.6664 24.1318 50.0686 24.6207 50.0152 25.1704C49.9617 25.7201 49.4727 26.1224 48.923 26.0689C48.4551 26.0233 47.9804 26 47.5 26C47.0196 26 46.5449 26.0233 46.077 26.0689C45.5273 26.1224 45.0383 25.7201 44.9848 25.1704C44.9314 24.6207 45.3336 24.1318 45.8833 24.0783ZM42.0119 25.965C42.2402 26.4679 42.0175 27.0606 41.5146 27.2888C40.6455 27.6833 39.8219 28.1611 39.0542 28.7122C38.6055 29.0343 37.9807 28.9316 37.6587 28.483C37.3366 28.0343 37.4392 27.4095 37.8879 27.0875C38.7611 26.4606 39.6984 25.9167 40.6881 25.4676C41.191 25.2394 41.7837 25.462 42.0119 25.965ZM52.9881 25.965C53.2163 25.462 53.809 25.2394 54.3119 25.4676C55.3016 25.9167 56.2389 26.4606 57.1121 27.0875C57.5608 27.4095 57.6634 28.0343 57.3413 28.483C57.0193 28.9316 56.3945 29.0343 55.9458 28.7122C55.1781 28.1611 54.3545 27.6833 53.4854 27.2888C52.9825 27.0606 52.7598 26.4679 52.9881 25.965ZM35.483 30.6587C35.9316 30.9807 36.0343 31.6055 35.7122 32.0542C35.1611 32.8219 34.6833 33.6455 34.2888 34.5146C34.0606 35.0175 33.4679 35.2402 32.965 35.0119C32.462 34.7837 32.2394 34.191 32.4676 33.6881C32.9167 32.6984 33.4606 31.7611 34.0875 30.8879C34.4095 30.4392 35.0343 30.3366 35.483 30.6587ZM59.517 30.6587C59.9657 30.3366 60.5905 30.4392 60.9125 30.8879C61.5394 31.7611 62.0833 32.6984 62.5324 33.6881C62.7606 34.191 62.538 34.7837 62.035 35.0119C61.5321 35.2402 60.9394 35.0175 60.7112 34.5146C60.3167 33.6455 59.8389 32.8219 59.2878 32.0542C58.9657 31.6055 59.0684 30.9807 59.517 30.6587ZM32.1704 37.9848C32.7201 38.0383 33.1224 38.5273 33.0689 39.077C33.0233 39.5449 33 40.0196 33 40.5C33 40.9804 33.0233 41.4551 33.0689 41.923C33.1224 42.4727 32.7201 42.9617 32.1704 43.0152C31.6207 43.0686 31.1318 42.6664 31.0783 42.1167C31.0265 41.5845 31 41.0452 31 40.5C31 39.9548 31.0265 39.4155 31.0783 38.8833C31.1318 38.3336 31.6207 37.9314 32.1704 37.9848ZM62.8296 37.9848C63.3793 37.9314 63.8682 38.3336 63.9217 38.8833C63.9735 39.4155 64 39.9548 64 40.5C64 41.0452 63.9735 41.5845 63.9217 42.1167C63.8682 42.6664 63.3793 43.0686 62.8296 43.0152C62.2799 42.9617 61.8776 42.4727 61.9311 41.923C61.9767 41.4551 62 40.9804 62 40.5C62 40.0196 61.9767 39.5449 61.9311 39.077C61.8776 38.5273 62.2799 38.0383 62.8296 37.9848ZM32.965 45.9881C33.4679 45.7598 34.0606 45.9825 34.2888 46.4854C34.6833 47.3545 35.1611 48.1781 35.7122 48.9458C36.0343 49.3945 35.9316 50.0193 35.483 50.3413C35.0343 50.6634 34.4095 50.5608 34.0875 50.1121C33.4606 49.2389 32.9167 48.3016 32.4676 47.3119C32.2394 46.809 32.462 46.2163 32.965 45.9881ZM62.035 45.9881C62.538 46.2163 62.7606 46.809 62.5324 47.3119C62.0833 48.3016 61.5394 49.2389 60.9125 50.1121C60.5905 50.5608 59.9657 50.6634 59.517 50.3413C59.0684 50.0193 58.9657 49.3945 59.2878 48.9458C59.8389 48.1781 60.3167 47.3545 60.7112 46.4854C60.9394 45.9825 61.5321 45.7598 62.035 45.9881ZM37.6587 52.517C37.9807 52.0684 38.6055 51.9657 39.0542 52.2878C39.8219 52.8389 40.6455 53.3167 41.5146 53.7112C42.0175 53.9394 42.2402 54.5321 42.0119 55.035C41.7837 55.538 41.191 55.7606 40.6881 55.5324C39.6984 55.0833 38.7611 54.5394 37.8879 53.9125C37.4392 53.5905 37.3366 52.9657 37.6587 52.517ZM57.3413 52.517C57.6634 52.9657 57.5608 53.5905 57.1121 53.9125C56.2389 54.5394 55.3016 55.0833 54.3119 55.5324C53.809 55.7606 53.2163 55.538 52.9881 55.035C52.7598 54.5321 52.9825 53.9394 53.4854 53.7112C54.3545 53.3167 55.1781 52.8389 55.9458 52.2878C56.3945 51.9657 57.0193 52.0684 57.3413 52.517ZM44.9848 55.8296C45.0383 55.2799 45.5273 54.8776 46.077 54.9311C46.5449 54.9767 47.0196 55 47.5 55C47.9804 55 48.4551 54.9767 48.923 54.9311C49.4727 54.8776 49.9617 55.2799 50.0152 55.8296C50.0686 56.3793 49.6664 56.8682 49.1167 56.9217C48.5845 56.9735 48.0452 57 47.5 57C46.9548 57 46.4155 56.9735 45.8833 56.9217C45.3336 56.8682 44.9314 56.3793 44.9848 55.8296Z"
        fill="#F49F50"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.5607 34.9393C57.1464 35.5251 57.1464 36.4749 56.5607 37.0607L46.1865 47.4349L39.926 41.0139C39.3477 40.4207 39.3597 39.4711 39.9529 38.8927C40.546 38.3144 41.4957 38.3264 42.074 38.9196L46.2135 43.1652L54.4393 34.9393C55.0251 34.3536 55.9749 34.3536 56.5607 34.9393Z"
        fill="#F49F50"
      />
    </svg>
  );
};
